import styled from "styled-components";

const ReportsBuilderStyles = styled.div`
  .addButton {
    text-align: center;
    padding: 25px 10px 21px;
    background-color: #fafafa;
    margin-bottom: 10px;
  }

  .historyButtonContainer {
    text-align: center;
    background-color: #fafafa;
    padding 20px 10px;
    margin-top: 20px;
    
    .icon {
      margin-right: 5px;
    }
  }
`;

export default ReportsBuilderStyles;
